import React, {Component} from 'react'
import PropTypes from 'prop-types'
import t from 'tcomb-form'
import model from './model'
import options from './options'
import {Button, Message} from '@sabre/spark-react'

const defaultFormState = {}

export default class Login extends Component {

    onSubmit = (e) => {
        e.preventDefault()
        if (!this.refs.form || this.refs.form.getValue()) {
            this.props.actions.onLoginSubmit(this.state.value)
            this.setState({value: defaultFormState})
        }
    }
    onChange = (value) => {
        this.setState({options: options, value: value})
    }

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: options,
            value: defaultFormState
        }
    }

    render() {
        return (
            <div>
                <i className="spark-logo spark-logo--sabre spark-logo--md spark-logo--sabre-red">Sabre</i>
                <h3 className="spark-splash-screen__heading">Web Pilot Briefing</h3>
                <form onSubmit={this.onSubmit} className="spark-splash-screen__form spark-text-left">
                    <t.form.Form
                        ref="form"
                        type={model}
                        options={this.state.options}
                        value={this.state.value}
                        onChange={this.onChange}/>
                    {this.props.error &&
                    <Message title={this.props.errorMessage} type="error" inline/>}
                    <nav className="spark-btn-group">
                        {!this.props.isLoading &&
                        <Button onClick={this.onSubmit} className="focus" type="submit">SIGN IN</Button>}
                        {this.props.isLoading &&
                        <Button onClick={this.onSubmit} className="focus" loading>Checking</Button>}
                    </nav>
                </form>
            </div>
        )
    }
}

Login.propTypes = {
    actions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string
}




// WEBPACK FOOTER //
// ./src/screens/login/components/forms/Login/form.js